import { render, staticRenderFns } from "./WFList.vue?vue&type=template&id=39fa0115&"
import script from "./WFList.vue?vue&type=script&lang=js&"
export * from "./WFList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports